<template>
  <div class="app-wrapper">
    <div class="headerCon">
      <div class="header">
        <div class="h_left">
          <img class="index" src="@/assets/img/home-ico.png" alt="" style="display:inline !important">
          <span class="iconCon" @click="tother">中国政协传媒网首页</span>
          <span class="time">{{date}}</span>  
        </div>
        <div class="h_right">
          <div>
            <span @click="toNews('xw')">新闻</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="toNews('lz')">履职</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="toNews('ll')">理论</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="toNews('rw')">人物</span>
            <el-divider direction="vertical"></el-divider>
            <span  @click="toNews('wh')">文化</span>
          </div>    
        </div>
        
      </div>
    </div>
    <div class="logoBox">
      <div class="logoCon">
        <div class="l_left" @click="toIndex">
          <img src="@/assets/img/logo.png" alt="">
          <span class="logoWord">杂志专栏</span>
        </div>
        <div class="l_right">
          <el-form ref="searchForm" inline :model="formData">
            <el-form-item class="searchIpt">
              <el-input v-model="formData.keywords" placeholder="请输入要查询的关键词"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" icon="el-icon-search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div>
            <span class="searchTip" v-for="(item,index) in searchList" :key="index" @click="tomanagizeList(item)">{{item.hotSearchWord}}</span>
          </div>
        </div>
      </div>
    </div>
    <el-breadcrumb v-if="hasbreach" class="app-breadcrumb"  separator-class="el-icon-arrow-right">
      <img src="@/assets/img/place.png" class="location_img">
      <span class='text active'>您的当前位置：</span>
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path" class="nav_list_box">
        <span @click="changePage(item,index)" class="active" style="cursor: pointer;" v-if="item.meta.title">{{item.meta.title}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <router-view class="containAll" @listenToChildrenEvent="showMsgFromChildren" @listenChildren="showKeywordsFromChild" style="margin-bottom: 0"></router-view>   
    <div class="footerBox">
      <p class="aboutUs">
          <span @click="aboutUs('http://www.zgzx.com.cn/node_44638.htm')">关于我们</span>
          <el-divider direction="vertical"></el-divider>
          <span @click="aboutUs('http://www.zgzx.com.cn/2010-10/30/content_8583883.htm')">联系我们</span>
          <el-divider direction="vertical"></el-divider>
          <span @click="aboutUs('http://www.zgzx.com.cn/2000-02/20/content_8583885.htm')">订阅服务</span>
          <el-divider direction="vertical"></el-divider>
          <span @click="aboutUs('http://www.zgzx.com.cn/2014-01/06/content_8608325.htm')">广告服务</span>
          <el-divider direction="vertical"></el-divider>
          <span @click="aboutUs('http://www.zgzx.com.cn/2021-11/17/content_9855126.htm')">来稿来信</span>
      </p>
      <p class="copy">版权所有：《中国政协》杂志社　电话：010-66192616 010-66192614</p>
      <p class="email">邮政编码：100811　电子邮箱：zgzxcmw@126.com　联系地址：北京市西城区太平桥大街23号　备案序号：京ICP备12000706</p>
    </div>
  </div>
</template>

<script>
import { gethoswAPI } from "@/api/index/index.js";
import { constantRouterMap } from '@/router'
let routerArr = []
export default {
  data () {
    
    return {

      date:'',
      message:'',
      hasbreach:null,
      formData:{
        keywords:null
      },
      breach:null,
      levelList:null,
      searchList:[],
      weekday:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]
    }
  },
  created() {
    this.getBreadcrumb();
    if(this.$route.name=='index'){
      this.hasbreach=false
    }else{
      this.hasbreach=true
    }
  },
  mounted(){
    //获取系统时间
    this.getTime();
    this.gethosw()
    
    console.log(this.message,"ppp")
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb();
      this.formData.keywords=this.$route.query.keywords
      if(this.$route.name=='index'){
        this.hasbreach=false
      }else{
        this.hasbreach=true
      }
    }
  },
  methods:{
    showMsgFromChildren(data){
      this.message=data
    },
    showKeywordsFromChild(data){
      this.formData.keywords=data;
    },
    //获取热词
    gethosw(){
      gethoswAPI(10).then(res=>{
        if(res.data.code==0){
            this.searchList=res.data.data
        }
      })
    },
    //获取当前时间
    getTime(){
      let  currentDate = new Date();
      let minu=currentDate.getMinutes()>9?currentDate.getMinutes():'0'+currentDate.getMinutes()
      this.date=currentDate.getFullYear()+'年'+(currentDate.getMonth()+1)+'月'+currentDate.getDate()+'日 '+currentDate.getHours()+':'+minu+' '+this.weekday[currentDate.getDay()]
    },
    //搜索
    onSubmit(){
      if(this.formData.keywords){
        if(this.$route.query.keywords!=this.formData.keywords){
          this.$router.push({name:'magazine',query:{keywords:this.formData.keywords}});
        }
      }else{
        this.$router.push({name:'magazine',query:{keywords:''}});
      }
      
      
    },
    //面包
    getBreadcrumb() {
      routerArr = [] //清空数组
      this.$route.matched.map(el =>{//循环路由匹配到的组件类
        if(el.meta.fatherName){//判断是否有带有伪父元素的路由
          this.filterName(constantRouterMap,el.meta.fatherName) //加入到路由
        }
        if(el.meta.title) {//路由title
          routerArr.push(el)
        }
      })
      let index = [{ name: 'index', meta: { title: '首页' }}]
      routerArr = index.concat(routerArr) //合并带有首页的路由
      this.levelList = routerArr; //负值
    },
    filterName(arr,names) {//筛选路由
      let that = this
      arr.forEach(router => { //循环路由
        if(router.name == names){//判断father是否等于循环中的name
          if(router.meta.fatherName){//判断当前fatherName对应的路由是否还有fatherName
            that.filterName(constantRouterMap,router.meta.fatherName)
          }
          routerArr.push(router)
          return
        }
        else{
          if(router.children && router.children.length>0){
            that.filterName(router.children,names)
          }
        }
      })
    },
    //跳到指定页面
    changePage(item,index) {
      if(index < this.levelList.length-1) {
        if(this.message != null){
          if(this.message.type) {
            this.$router.push({name:item.name,query: { id: this.message.id,type: this.message.type, name: this.message.name }})
          }  else{
            this.$router.push({name:item.name,query: { id: this.message.bookId}})
          }
        } else{
          this.$router.push({name:item.name})
        }
      }
    },
    //热词跳到杂志
    tomanagizeList(item){
      
      if(this.$route.query.keywords!=item.hotSearchWord){
        this.formData.keywords=item.hotSearchWord;
        this.$router.push({name:'magazine',query:{keywords:this.formData.keywords}});
      }
      
    },
    //到政协官网
    tother(){
      window.open('http://www.zgzx.com.cn/')
    },
    //到杂志首页
    toIndex(){
      this.$router.push({name:'index'});
    },
    toNews(name){
      window.open('http://'+name+'.zgzx.com.cn/')
    },
    aboutUs(urls){
      window.open(urls)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.app-wrapper{
  background:  #FAFAFA url('../../assets/img/bg.png') no-repeat 0 calc(100% - 150px);
  background-size: 100% 664px;
  min-height:873px;
  .containAll{
    margin-bottom: 150px;
  }
  /deep/.el-breadcrumb__inner{
    color: #999999
  }
}

.headerCon{
  font-size: 14px;
  height: 40px;
  background: #484848;
  color: #AAAAAA;
  display: flex;
  justify-content: center;
  .header{
    width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .index{
      height: 15px;
      width: 17px;
      vertical-align: middle;
    }
    img{
      height: 15px;
      width: 17px;
      margin-right: 7px;
      margin-left: 30px;
    }
    .iconCon{
      cursor: pointer;
      display: inline-block;
      margin-right: 50px;
      color: #AAAAAA!important;
    }
    .h_right{
      cursor: pointer;
    }
  }
}
.logoBox{
  box-shadow:0px 1px 5px 0px rgba(51,51,51,0.2);
  background: white;
  .logoCon{
    width: 1200px;
    margin: 0 auto;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .l_left{
      display: flex;
      align-items: center;
      font-weight: bold;
      cursor: pointer;
    }
    .logoWord{
      color: #333;
      font-size: 24px;
    }
    img{
      height: 69px;
      width: 200px;
    }
    .l_right{
      margin-top: 25px;
      .el-form{
        height: 40px;
      }
      .searchTip{
        display: inline-block;
        margin-right: 20px;
        color: #888;
        font-size: 14px;
        margin-top: 16px;
        cursor: pointer;
      }
      .searchIpt{
        margin-bottom: 0;
        .el-input{
          width: 384px;
          margin-left: 0px;
          /deep/.el-input__inner{
            border: 1px solid #F55827!important;
            border-radius:0;
          }
        }
      }
      
      .el-button{
        background: #F55827;
        border-color:#F55827;
        border-radius:0;
        margin-left: -15px;
      }
    }
  }
}
.app-breadcrumb{
  width: 1200px;
  margin: 0 auto;
  height: 55px;
  display: flex;
  align-items: center;
  color: #999999;
  img{
    height: 21px;
    width: 12px;
    margin-right: 8px;
  }
}
.footerBox{
  height: 150px;
  background: #393939;
  font-size: 14px;
  color: #AAAAAA;
  overflow: hidden;
  width: 100%;
  p{
    text-align: center;
  }
  .aboutUs{
    margin: 33px 0 30px 0;
    span{
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue